import dateFormat, { formatDateTime } from "../../../../../utils/dateFormat";

export const accessHistoryHeader = [
  "Affiliate",
  "Branch",
  "Username",
  "Search Date",
];

export const accessHistoryBody = (accessHistory) => {
  const accessHistoryBody = accessHistory.map((history) => {
    console.log("HISTORY", history);
    const { accessor } = history || {};

    const dateDisplay = history?.searchDT
      ? formatDateTime(history.searchDT)
      : dateFormat(history.createdAt);

    return [
      accessor.affiliate.name,
      accessor.branch.name,
      accessor.username,
      // formatDateTime(history?.searchDT) || dateFormat(history.createdAt),
      dateDisplay,
    ];
  });

  return accessHistoryBody;
};
